import type eventEmitter from 'eventemitter3';
import type { Asset } from "@phantom/ph-domain";

import { DispatchEvents } from '../constants';
import { IFeatureConfig } from "../interfaces/IFeatureConfig";
import { IFeatureState } from "../interfaces/IFeatureState";

const handleFeatures = (dispatcher: eventEmitter, data: IFeatureConfig[]): void => {
    dispatcher.emit(DispatchEvents.SetFeatures, data);
};

const handleStates = (dispatcher: eventEmitter, data: IFeatureState[]): void => {
    dispatcher.emit(DispatchEvents.SetState, data);
};

const handleAssets = (dispatcher: eventEmitter, data: Asset[]): void => {
    dispatcher.emit(DispatchEvents.SetAssets, data);
};

const handleReset = (dispatcher: eventEmitter): void => {
    dispatcher.emit(DispatchEvents.Reset, []);
};

export const create = (dispatcher: eventEmitter): void => {
    window["LOCAL"] = {
        setState: (data: IFeatureState[]) => handleStates(dispatcher, data),
        setFeatures: (data: IFeatureConfig[]) => handleFeatures(dispatcher, data),
        setAssets: (data: Asset[]) => handleAssets(dispatcher, data),
        reset: () => handleReset(dispatcher),
    };
};
